module.exports = __webpack_public_path__ + "img/down-bg.6e04184b.png";